export const API = {
  create: {
    path: '/user-yacht-members',
    method: 'POST',
    get: null,
    auth: true,
    fallback: null,
  },
  update: {
    path: '/user-yacht-members/{{id}}',
    method: 'PUT',
    get: null,
    auth: true,
    fallback: null,
  },
};
